import React from 'react';
import {
  Image,
  Popup,
  Table,
  Flag,
  Button,
} from 'semantic-ui-react';

import _ from 'lodash';
import PropTypes from 'prop-types';
import InfluencerTableSocialLink from '../influencer-table-social-link';
import * as countryList from '../../utils/helpers/countries';
import { ierFormat } from '../../utils/helpers/formatting';

const DEFAULT_IMAGE = 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/no_image_available.png';

const badgeStyle = {
  display: 'flex',
  alignItems: 'center',
};

const avatarStyle = {
  marginRight: '10px',
};


const rowPadding = {
  padding: 8,
};
const influencerCellStyle = {
  ...rowPadding,
};
const font90 = {
  fontSize: '90%',
  color: 'grey',
};

const marginAuto = { margin: 'auto' };
const marginZero = { margin: 0 };


const getCountryTrigger = country => {
  const mapping = _.find(countryList.default, ['key', country]);
  const isGlobal = _.get(mapping, 'value') === 'ZZ';
  const flagName = _.get(mapping, 'flag', _.toLower(country));
  return isGlobal ? <Image style={marginAuto} src={mapping.image.src} /> : <Flag style={marginZero} name={flagName} />;
};
export default function MailoutInfluencerTableRow({ influencer, onDelete, isDeleting }) {
  const {
    name,
    instagramEngagementRate,
    instagram,
    instagramCount,
    country,
    email,
    instagramId,
    thumbnail,
  } = influencer;

  const thumb = thumbnail || `https://pics.dyzio.co/${instagramId}.jpg`;
  const isCountryValid = !_.isNil(country) && !_.isEmpty(country) && !_.isEqual(country, 'undefined');
  const mapping = _.find(countryList.default, ['key', country]);
  const countryName = (mapping && mapping.text) || '-';
  return (
    <Table.Row>
      <Table.Cell>
        <Button onClick={() => onDelete(instagramId)} icon="delete" circular loading={isDeleting} disabled={isDeleting} />
      </Table.Cell>
      <Table.Cell
        verticalAlign="middle"
        style={influencerCellStyle}
      >
        <div style={badgeStyle}>
          <div style={avatarStyle}>
            <a
              href={`https://instagram.com/${influencer.instagram}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                avatar
                src={thumb}
                size="tiny"
                // eslint-disable-next-line no-param-reassign
                onError={i => { i.target.src = DEFAULT_IMAGE; }}
              />
            </a>
          </div>
          <div>
            <b>{instagram}</b>
            <div className="light" style={font90}>
              { name }
            </div>
          </div>
        </div>
      </Table.Cell>

      <Table.Cell style={rowPadding}>
        {email}
      </Table.Cell>

      <Table.Cell textAlign="center" style={rowPadding}>
        {isCountryValid &&
          <Popup
            trigger={getCountryTrigger(country)}
            content={countryName}
          />
        }

        {!isCountryValid && '-'}
      </Table.Cell>

      <Table.Cell textAlign="center" style={rowPadding}>
        { instagramEngagementRate ? ierFormat(instagramEngagementRate) : '-' }
      </Table.Cell>

      <Table.Cell
        collapsing textAlign="center" style={rowPadding}
      >
        <a href={`https://www.instagram.com/${instagram}`} target="_blank" rel="noopener noreferrer">
          <InfluencerTableSocialLink
            count={instagramCount}
          />
        </a>

      </Table.Cell>
    </Table.Row>);
}

MailoutInfluencerTableRow.propTypes = {
  influencer: PropTypes.object.isRequired,
  onDelete: PropTypes.func,
  isDeleting: PropTypes.bool,
};

MailoutInfluencerTableRow.defaultProps = {
  onDelete: _.noop,
  isDeleting: false,
};



/** WEBPACK FOOTER **
 ** ./src/components/mailout-influencer-table-row/index.js
 **/